import { useEffect } from "react";
import { updateCertificationStatusById } from "api/certifications/certifications";

/**
 * Hook que detecta si la página fue recargada durante una sesión de examen
 * y actualiza el estado de la certificación a "interrumpida" (status 5) en ese caso.
 *
 * Este comportamiento se basa en una bandera en `sessionStorage` llamada `reloading`,
 * que debe establecerse antes de la recarga de la página.
 *
 * @param {Object} params - Parámetros necesarios para el hook.
 * @param {Object} params.certification - Objeto de certificación actual.
 * @param {string} params.token - Token de autenticación del usuario.
 */
const useSessionReloadHandler = ({ certification, token, onReload }) => {
	useEffect(() => {
		if (sessionStorage.getItem('reloading')) {
			sessionStorage.removeItem('reloading');
			onReload(); // Ejecuta la función que recibe como parámetro
		}
	}, []);
};

export default useSessionReloadHandler;